export const enum expenseConstants  {
  
  // Get Expense List
  getExpenseRequest = "GET_EXPENSE_REQUEST",
  getExpenseSuccess = "GET_EXPENSE_SUCCESS",
  getExpenseFailure = "GET_EXPENSE_FAILURE",

  // Get Expense List with Params
  getExpenseParamsRequest = "GET_EXPENSE_PARAMS_REQUEST",
  getExpenseParamsSuccess = "GET_EXPENSE_PARAMS_SUCCESS",
  getExpenseParamsFailure = "GET_EXPENSE_PARAMS_FAILURE",

  // Create/Update Expense
  createExpenseRequest = "CREATE_EXPENSE_REQUEST",
  createExpenseSuccess = "CREATE_EXPENSE_SUCCESS",
  createExpenseFailure = "CREATE_EXPENSE_FAILURE",
  createExpenseReset = "CREATE_EXPENSE_RESET",

  // Delete Expense
  deleteExpenseRequest = "DELETE_EXPENSE_REQUEST",
  deleteExpenseSuccess = "DELETE_EXPENSE_SUCCESS",
  deleteExpenseFailure = "DELETE_EXPENSE_FAILURE",
  deleteExpenseReset = "DELETE_EXPENSE_RESET",

  // Get Expense View
  expenseViewRequest = "EXPENSE_VIEW_REQUEST",
  expenseViewSuccess = "EXPENSE_VIEW_SUCCESS",
  expenseViewFailure = "EXPENSE_VIEW_FAILURE",
}
